/* eslint-disable no-underscore-dangle */
import { logError } from 'commons/logger';

const handleProductClick = (algoliaMetaData = {}) => {
  const objectID = algoliaMetaData?.objectID;
  const queryID = algoliaMetaData?.queryID;

  const isValidObjectID =
    typeof objectID === 'string' && objectID.trim().length > 0;

  const isValidQueryID =
    typeof queryID === 'string' && queryID.trim().length > 0;

  // Don't send event if we don't have valid search context
  if (!isValidObjectID || !isValidQueryID) {
    return;
  }

  const objectIDs = [objectID].filter(
    id => typeof id === 'string' && id.trim().length > 0
  );

  if (objectIDs.length === 0) {
    return;
  }

  if (window.aa && window.algoliaInitialized) {
    window.aa('clickedObjectIDsAfterSearch', {
      eventName: 'Product Clicked',
      userToken: window?.rudderanalytics?.getAnonymousId?.() || '',
      index: 'products_jb4',
      objectIDs,
      positions: [algoliaMetaData?.position ?? 0],
      queryID,
    });
  } else {
    logError('Algolia Insights not initialized yet.');
  }
};

export default handleProductClick;
